import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 z-20" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout" }
const _hoisted_4 = { class: "inline-flex" }
const _hoisted_5 = { class: "w-10/12" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row mt-4 gap-x-4"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "w-full" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "flex flex-row mt-4 gap-x-4"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "w-full" }, null, -1)
const _hoisted_10 = { class: "flex flex-row mt-4 gap-x-4" }
const _hoisted_11 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_12 = { class: "text-gray-lp-500 font-normal" }
const _hoisted_13 = { class: "ml-1 relative" }
const _hoisted_14 = { class: "opacity-75" }
const _hoisted_15 = { class: "flex flex-row mt-4 gap-x-4" }
const _hoisted_16 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, "Shipment ID", -1)
const _hoisted_18 = { class: "ml-1 relative" }
const _hoisted_19 = { class: "opacity-75" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "w-full" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_22 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_23 = { class: "flex flex-row mt-4" }
const _hoisted_24 = { class: "w-1/2 mr-4" }
const _hoisted_25 = { class: "w-1/2" }
const _hoisted_26 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_27 = { class: "flex flex-row mb-6 mt-0" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_29 = { class: "w-1/2 ml-6 flex flex-col" }
const _hoisted_30 = { class: "flex flex-row" }
const _hoisted_31 = { class: "flex flex-row" }
const _hoisted_32 = { class: "mx-2" }
const _hoisted_33 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Tipe Alamat wajib diisi ")
const _hoisted_36 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_37 = {
  key: 2,
  class: "flex flex-row my-6"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_39 = { class: "w-1/2 ml-6" }
const _hoisted_40 = { class: "flex flex-row text-12px xxl:text-14px relative" }
const _hoisted_41 = { class: "w-1/2 mr-4" }
const _hoisted_42 = { class: "p-field-checkbox mt-3" }
const _hoisted_43 = { class: "w-1/2" }
const _hoisted_44 = { class: "p-field-checkbox mt-3" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_47 = { class: "text-14px" }
const _hoisted_48 = { class: "flex flex-row mt-4 space-x-4" }
const _hoisted_49 = { class: "w-1/2" }
const _hoisted_50 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_51 = { class: "text-12px xxl:text-14px" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_53 = { class: "ml-1 relative" }
const _hoisted_54 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-1000"
}
const _hoisted_55 = { class: "flex flex-row justify-between mt-4 text-12px xxl:text-14px" }
const _hoisted_56 = { class: "w-1/2 pr-3" }
const _hoisted_57 = {
  key: 4,
  class: "flex flex-row text-12px xxl:text-14px relative mt-4 space-x-4"
}
const _hoisted_58 = { for: "cod" }
const _hoisted_59 = {
  key: 5,
  class: "flex flex-row text-12px xxl:text-14px mt-4 space-x-4 items-center"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_61 = { key: 6 }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_63 = { class: "flex flex-row mt-4" }
const _hoisted_64 = { class: "w-full mr-2" }
const _hoisted_65 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_66 = { class: "text-12px xxl:text-14px" }
const _hoisted_67 = {
  key: 0,
  class: "text-red-lp-300 font-normal pl-1"
}
const _hoisted_68 = { class: "ml-1 relative" }
const _hoisted_69 = { class: "w-full ml-2" }
const _hoisted_70 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_71 = { class: "text-12px xxl:text-14px" }
const _hoisted_72 = {
  key: 0,
  class: "text-red-lp-300 font-normal pl-1"
}
const _hoisted_73 = {
  key: 1,
  class: "text-gray-lp-500 font-normal"
}
const _hoisted_74 = { class: "ml-1 relative" }
const _hoisted_75 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "warning"
}, null, -1)
const _hoisted_77 = { class: "flex flex-row mt-4" }
const _hoisted_78 = {
  key: 0,
  class: "w-full mr-2"
}
const _hoisted_79 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_80 = /*#__PURE__*/_createVNode("p", null, "Piece Per Pack", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_82 = { class: "ml-1 relative" }
const _hoisted_83 = {
  key: 1,
  class: "w-full ml-2"
}
const _hoisted_84 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_85 = /*#__PURE__*/_createVNode("p", null, "Komoditas Selanjutnya", -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_87 = { class: "ml-1 relative" }
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_89 = { class: "flex w-full flex-row gap-x-6 pt-6" }
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "w-1/12 font-semibold text-12px xxl:text-14px text-center text-gray-lp-300" }, " No ", -1)
const _hoisted_91 = { class: "w-40 font-semibold text-12px xxl:text-14px flex flex-row text-gray-lp-300" }
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "font-normal text-gray-lp-500" }, " (kg)", -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_94 = { class: "relative" }
const _hoisted_95 = { class: "w-4/12 font-semibold text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_96 = { class: "font-normal text-gray-lp-500" }
const _hoisted_97 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-normal pl-1" }, "*", -1)
const _hoisted_98 = { class: "w-36 font-semibold text-14p text-center text-gray-lp-300" }
const _hoisted_99 = { class: "w-full" }
const _hoisted_100 = /*#__PURE__*/_createVNode("div", { class: "border-t mt-4" }, null, -1)
const _hoisted_101 = { class: "flex flex-row items-center gap-x-6" }
const _hoisted_102 = { class: "w-1/12 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_103 = { class: "w-40" }
const _hoisted_104 = { class: "w-4/12 bg-white" }
const _hoisted_105 = { class: "w-36 text-12px xxl:text-14px font-montserrat text-center" }
const _hoisted_106 = {
  key: 0,
  class: "flex flex-row pl-5 pt-1"
}
const _hoisted_107 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_108 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_109 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_110 = {
  key: 0,
  class: "flex flex-row justify-start gap-x-6"
}
const _hoisted_111 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_112 = { class: "flex flex-row px-4 pt-2 pb-3 rounded-md mt-4 w-max bg-warning-hws" }
const _hoisted_113 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 text-12px" }, null, -1)
const _hoisted_114 = {
  key: 8,
  class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2 pt-2 pb-4"
}
const _hoisted_115 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_116 = { key: 0 }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { class: "flex flex-col justify-around w-full" }
const _hoisted_119 = { class: "flex flex-row justify-between text-gray-lp-300 font-semibold text-12px xxl:text-14px" }
const _hoisted_120 = { class: "flex flex-col" }
const _hoisted_121 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_123 = { class: "flex flex-col" }
const _hoisted_124 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" Promo Berat ")
const _hoisted_126 = /*#__PURE__*/_createVNode("div", { class: "border-t-2 mt-4" }, null, -1)
const _hoisted_127 = { class: "flex flex-row justify-between text-gray-lp-300 font-semibold text-12px xxl:text-14px mt-4" }
const _hoisted_128 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-400" }, null, -1)
const _hoisted_129 = { class: "text-14px pt-5 text-black-lp-300 font-bold" }
const _hoisted_130 = { class: "flex items-center justify-center py-3" }
const _hoisted_131 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_132 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_Calculation = _resolveComponent("Calculation")!
  const _component_Uncalculation = _resolveComponent("Uncalculation")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_LpInputSearch = _resolveComponent("LpInputSearch")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ErrorMessageBooking = _resolveComponent("ErrorMessageBooking")!
  const _component_WarningSttCod = _resolveComponent("WarningSttCod")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_BannerProductType = _resolveComponent("BannerProductType")!
  const _component_product_poster = _resolveComponent("product-poster")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Woodpacking = _resolveComponent("Woodpacking")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AdditionalInfo = _resolveComponent("AdditionalInfo")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_SectionUploadPhotoForWeightAdjustment = _resolveComponent("SectionUploadPhotoForWeightAdjustment")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_card = _resolveComponent("card")!
  const _component_ModalErrorNotAllowEdit = _resolveComponent("ModalErrorNotAllowEdit")!

  return (_ctx.isLoadingDetail)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, { key: 0 }))
    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("img", {
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "w-5 mr-3 cursor-pointer",
              alt: "back"
            }),
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getTitle), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            (_ctx.visiblePrice || _ctx.shipmentC1Cod)
              ? (_openBlock(), _createBlock(_component_Calculation, {
                  key: 0,
                  dataCalculation: _ctx.manualBooking,
                  isDisabled: 
            !_ctx.isFormValid ||
              _ctx.isDisabledButton ||
              (_ctx.eligibleAdditionalInfo &&
                (_ctx.disableDetailCommodity || _ctx.disableProofCommodity)) || _ctx.isErrorHws
          ,
                  payload: _ctx.payload,
                  formType: _ctx.formType,
                  bookingType: _ctx.bookingType,
                  isSttForeign: _ctx.isSttForeign,
                  onSetDiscount: _ctx.setDiscount
                }, null, 8, ["dataCalculation", "isDisabled", "payload", "formType", "bookingType", "isSttForeign", "onSetDiscount"]))
              : (_openBlock(), _createBlock(_component_Uncalculation, {
                  key: 1,
                  isDisabled: 
            !_ctx.isFormValid ||
              _ctx.isDisabledButton ||
              (_ctx.eligibleAdditionalInfo &&
                (_ctx.disableDetailCommodity || _ctx.disableProofCommodity)) || _ctx.isErrorHws
          ,
                  payload: _ctx.payload,
                  bookingType: _ctx.bookingType
                }, null, 8, ["isDisabled", "payload", "bookingType"]))
          ])
        ]),
        (_openBlock(), _createBlock("div", {
          class: "w-full px-4 text-12px xxl:text-14px overflow-y-auto pb-20 mt-6",
          key: _ctx.reRenderManualBooking
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Title, {
              label: _ctx.$t('bookingShipment.column.detailShipment')
            }, null, 8, ["label"]),
            (_ctx.isSttRetail)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.column.paymentMethod'),
                    class: "w-full mr-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        class: "my-2",
                        "model-value": _ctx.checkoutPaymentMethod,
                        disabled: ""
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _hoisted_7
                ]))
              : _createCommentVNode("", true),
            (_ctx.formType === 'client' && !_ctx.isSttForeign)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('bookingShipment.column.clientName'),
                    asterisk: "",
                    class: "w-full mr-12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectSearch, {
                        isFirstInput: true,
                        options: [],
                        class: ["my-2", _ctx.formType === 'client' ? 'opacity-75' : ''],
                        placeholder: "Pilih Client",
                        modelValue: _ctx.manualBooking.sttClient.clientName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.manualBooking.sttClient.clientName = $event)),
                        isDisabled: true
                      }, null, 8, ["class", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_DataWrapper, { class: "w-full mr-4" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.column.manualSttNumber')) + " ", 1),
                      _createVNode("span", _hoisted_12, "(" + _toDisplayString(_ctx.$t('optional')) + ")", 1)
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("img", {
                        onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenTooltipManualSTT = true)),
                        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpenTooltipManualSTT = false)),
                        src: 
                    _ctx.isOpenTooltipManualSTT
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: _ctx.$t('bookingShipment.tooltip.manualStt'),
                        message: _ctx.$t('bookingShipment.tooltip.manualSttMsg'),
                        footer: "",
                        style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                      }, null, 8, ["title", "message"]), [
                        [_vShow, _ctx.isOpenTooltipManualSTT]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode(_component_lp_input, {
                      isFirstInput: _ctx.formType !== 'client',
                      modelValue: _ctx.manualBooking.sttNo,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.manualBooking.sttNo = $event)),
                      disabled: true
                    }, null, 8, ["isFirstInput", "modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.externalRefNumber'),
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", {
                    class: _ctx.formType === 'client' ? 'opacity-75' : ''
                  }, [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.manualBooking.sttNoRefExternal,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.manualBooking.sttNoRefExternal = $event)),
                      placeholder: "DOR00989",
                      onChange: _ctx.checkFocus,
                      errorCaption: "Mohon isi No. Referensi Eksternal",
                      disabled: 
                  _ctx.formType === 'client' ||
                    _ctx.customPath === 'on-process-stt' ||
                    _ctx.isLastStatusProofOfDelivery ||
                    _ctx.isReverseJourneyPrefix
                ,
                      showMaxLength: true,
                      maxLength: 100
                    }, null, 8, ["modelValue", "onChange", "disabled"])
                  ], 2)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_15, [
              (!_ctx.isSttForeign)
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 0,
                    class: "w-full mr-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode("div", _hoisted_18, [
                          _createVNode("img", {
                            onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isOpenTooltipShipmentID = true)),
                            onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isOpenTooltipShipmentID = false)),
                            src: 
                    _ctx.isOpenTooltipShipmentID
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: "Shipment ID",
                            message: "Isi Shipment ID dengan kode booking marketplace yang tertera pada paket (XYZ00xxx).",
                            footer: "",
                            style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.6em"}
                          }, null, 512), [
                            [_vShow, _ctx.isOpenTooltipShipmentID]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_19, [
                        _createVNode(_component_lp_input, {
                          modelValue: _ctx.manualBooking.sttShipmentId,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.manualBooking.sttShipmentId = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_20
            ]),
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.shipperName'),
                asterisk: "",
                class: "w-full mr-4"
              }, {
                default: _withCtx(() => [
                  (_ctx.urlVersion === 'v2')
                    ? (_openBlock(), _createBlock(_component_SelectSearch, {
                        key: 0,
                        onFocus: _cache[10] || (_cache[10] = 
                e => {
                  _ctx.setFieldIndex(1);
                }
              ),
                        onChange: _ctx.onChooseSenders,
                        onFilter: _cache[11] || (_cache[11] = e => _ctx.setNameCustomer(e, 'senders')),
                        placeholder: _ctx.$t('bookingShipment.placeholder.shipperName'),
                        class: "mt-2",
                        options: _ctx.senders,
                        modelValue: _ctx.manualBooking.sttSenderName,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.manualBooking.sttSenderName = $event)),
                        isLoading: _ctx.isLoadingCustomer,
                        keyName: "customerName",
                        secondKeyName: "customerPhoneNumber",
                        keyValue: "customerName",
                        isShowErrorIndicator: _ctx.errorMandatory[1],
                        errorCaption: 
                _ctx.errorMandatory[1] ? _ctx.$t('bookingShipment.error.senderName') : ''
              ,
                        maxLength: 250,
                        isDisabled: _ctx.isDisableDeliverySender
                      }, null, 8, ["onChange", "placeholder", "options", "modelValue", "isLoading", "isShowErrorIndicator", "errorCaption", "isDisabled"]))
                    : (_openBlock(), _createBlock(_component_LpInputSearch, {
                        key: 1,
                        class: "my-2",
                        options: _ctx.senders,
                        onFilter: _cache[13] || (_cache[13] = e => _ctx.setNameCustomer(e, 'senders')),
                        onInputFilter: _cache[14] || (_cache[14] = e => _ctx.setCustomer(e, 'senders')),
                        onFocus: _cache[15] || (_cache[15] = 
                e => {
                  _ctx.setFieldIndex(1);
                }
              ),
                        isLoading: _ctx.isLoadingCustomer,
                        keyName: "customerName",
                        secondKeyName: "customerPhoneNumber",
                        keyValue: "customerName",
                        "onUpdate:modelValue": [
                          _ctx.onChooseSenders,
                          _cache[16] || (_cache[16] = ($event: any) => (_ctx.manualBooking.sttSenderName = $event))
                        ],
                        placeholder: _ctx.$t('bookingShipment.error.senderName'),
                        modelValue: _ctx.manualBooking.sttSenderName,
                        isShowErrorIndicator: _ctx.errorMandatory[1],
                        errorCaption: 
                _ctx.errorMandatory[1] ? 'Nama pengirim wajib diisi' : ''
              ,
                        maxLength: 250,
                        isDisabled: _ctx.isDisableDeliverySender
                      }, null, 8, ["options", "isLoading", "onUpdate:modelValue", "placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "isDisabled"]))
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.recipientName'),
                asterisk: "",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  (_ctx.urlVersion === 'v2')
                    ? (_openBlock(), _createBlock(_component_SelectSearch, {
                        key: 0,
                        onFocus: _cache[17] || (_cache[17] = 
                e => {
                  _ctx.setFieldIndex(2);
                }
              ),
                        onChange: _ctx.onChooseReceivers,
                        onFilter: _cache[18] || (_cache[18] = e => _ctx.setNameCustomer(e, 'receivers')),
                        placeholder: _ctx.$t('bookingShipment.placeholder.recipientName'),
                        class: "mt-2",
                        options: _ctx.receivers,
                        modelValue: _ctx.manualBooking.sttRecipientName,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.manualBooking.sttRecipientName = $event)),
                        isLoading: _ctx.isLoadingCustomer,
                        keyName: "customerName",
                        secondKeyName: "customerPhoneNumber",
                        keyValue: "customerName",
                        isShowErrorIndicator: _ctx.errorMandatory[2],
                        errorCaption: 
                _ctx.errorMandatory[2] ? _ctx.$t('bookingShipment.error.recipientName') : ''
              ,
                        maxLength: 250,
                        isDisabled: _ctx.isDisableDeliveryReceiver
                      }, null, 8, ["onChange", "placeholder", "options", "modelValue", "isLoading", "isShowErrorIndicator", "errorCaption", "isDisabled"]))
                    : (_openBlock(), _createBlock(_component_LpInputSearch, {
                        key: 1,
                        class: "my-2",
                        options: _ctx.receivers,
                        onFilter: _cache[20] || (_cache[20] = e => _ctx.setNameCustomer(e, 'receivers')),
                        onInputFilter: _cache[21] || (_cache[21] = e => _ctx.setCustomer(e, 'receivers')),
                        onFocus: _cache[22] || (_cache[22] = 
                e => {
                  _ctx.setFieldIndex(2);
                }
              ),
                        isLoading: _ctx.isLoadingCustomer,
                        keyName: "customerName",
                        secondKeyName: "customerPhoneNumber",
                        keyValue: "customerName",
                        "onUpdate:modelValue": [
                          _ctx.onChooseReceivers,
                          _cache[23] || (_cache[23] = ($event: any) => (_ctx.manualBooking.sttRecipientName = $event))
                        ],
                        placeholder: _ctx.$t('bookingShipment.placeholder.recipientName'),
                        modelValue: _ctx.manualBooking.sttRecipientName,
                        isShowErrorIndicator: _ctx.errorMandatory[2],
                        errorCaption: 
                _ctx.errorMandatory[2] ? _ctx.$t('bookingShipment.error.recipientName') : ''
              ,
                        maxLength: 250,
                        isDisabled: _ctx.isDisableDeliveryReceiver
                      }, null, 8, ["options", "isLoading", "onUpdate:modelValue", "placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "isDisabled"]))
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.shipperPhoneNumber'),
                  asterisk: "",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectPhoneCountry, {
                      column: "Pengirim",
                      error: _ctx.errorPhoneSender,
                      phone: _ctx.manualBooking.sttSenderPhone,
                      code: _ctx.manualBooking.sttSenderPhoneCode,
                      flag: _ctx.manualBooking.sttSenderPhoneFlag,
                      onSetPhone: _ctx.setPhoneSender,
                      onSetPhoneCode: _ctx.setPhoneCodeSender,
                      onSetPhoneFlag: _ctx.setPhoneFlagSender,
                      onSetErrorPhone: _ctx.setErrorPhoneSender,
                      onSetErrorPhoneCode: _ctx.setErrorPhoneCodeSender,
                      onCheckFocus: _ctx.checkFocus,
                      onSetErrorCharMinimal: _ctx.setErrorCharMinimalSender,
                      disabled: _ctx.isDisableDeliverySender,
                      onSetFieldIndex: _cache[24] || (_cache[24] = ($event: any) => (_ctx.setFieldIndex(3)))
                    }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhone", "onSetErrorPhoneCode", "onCheckFocus", "onSetErrorCharMinimal", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.recipientPhoneNumber'),
                  asterisk: "",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectPhoneCountry, {
                      column: "Penerima",
                      error: _ctx.errorPhoneReceiver,
                      phone: _ctx.manualBooking.sttRecipientPhone,
                      code: _ctx.manualBooking.sttRecipientPhoneCode,
                      flag: _ctx.manualBooking.sttRecipientPhoneFlag,
                      onSetPhone: _ctx.setPhoneReceiver,
                      onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                      onSetPhoneFlag: _ctx.setPhoneFlagReceiver,
                      onSetErrorPhone: _ctx.setErrorPhoneReceiver,
                      onSetErrorPhoneCode: _ctx.setErrorPhoneCodeReceiver,
                      onCheckFocus: _ctx.checkFocus,
                      onSetErrorCharMinimal: _ctx.setErrorCharMinimalReceiver,
                      disabled: _ctx.isDisableDeliveryReceiver,
                      onSetFieldIndex: _cache[25] || (_cache[25] = ($event: any) => (_ctx.setFieldIndex(4)))
                    }, null, 8, ["error", "phone", "code", "flag", "onSetPhone", "onSetPhoneCode", "onSetPhoneFlag", "onSetErrorPhone", "onSetErrorPhoneCode", "onCheckFocus", "onSetErrorCharMinimal", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.shipperAddress'),
                asterisk: "",
                class: "w-full mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "textarea",
                    modelValue: _ctx.manualBooking.sttSenderAddress,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.manualBooking.sttSenderAddress = $event)),
                    onChange: _ctx.checkFocus,
                    error: 
                _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[5]
              ,
                    "error-caption": 
                _ctx.errorMandatory[5]
                  ? _ctx.$t('bookingShipment.error.senderAddress')
                  : _ctx.$t('bookingShipment.error.sameOriginDestination')
              ,
                    preventEnterTextArea: true,
                    format: _ctx.replaceNewLine,
                    placeholder: _ctx.$t('bookingShipment.placeholder.shipperAddress'),
                    maxLength: _ctx.maxAddressLength,
                    showMaxLength: true,
                    disabled: _ctx.isDisableDeliverySender,
                    onFocus: _cache[27] || (_cache[27] = ($event: any) => (_ctx.setFieldIndex(5)))
                  }, null, 8, ["modelValue", "onChange", "error", "error-caption", "format", "placeholder", "maxLength", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.recipientAddress'),
                asterisk: "",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    type: "textarea",
                    modelValue: _ctx.manualBooking.sttRecipientAddress,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.manualBooking.sttRecipientAddress = $event)),
                    error: 
                _ctx.isShipperAndConsigneeAddressIdentical || _ctx.errorMandatory[6]
              ,
                    "error-caption": 
                _ctx.errorMandatory[6]
                  ? _ctx.$t('bookingShipment.error.recepientAddress')
                  : _ctx.$t('bookingShipment.error.sameOriginDestination')
              ,
                    onChange: _ctx.checkFocus,
                    preventEnterTextArea: true,
                    format: _ctx.replaceNewLine,
                    placeholder: _ctx.$t('bookingShipment.placeholder.recipientAddress'),
                    maxLength: _ctx.maxAddressLength,
                    showMaxLength: true,
                    disabled: _ctx.isDisableDeliveryReceiver,
                    onFocus: _cache[29] || (_cache[29] = ($event: any) => (_ctx.setFieldIndex(6)))
                  }, null, 8, ["modelValue", "error", "error-caption", "onChange", "format", "placeholder", "maxLength", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAddressType, (item, index) => {
                    return (_openBlock(), _createBlock("label", {
                      key: index,
                      class: 
                  (_ctx.currentFieldIndex > 6.5 &&
                    !_ctx.manualBooking.sttRecipientAddressType) ||
                  !_ctx.manualBooking.sttRecipientAddressType
                    ? 'radioCustomError'
                    : 'radioCustom'
                
                    }, [
                      _createVNode("input", {
                        type: "radio",
                        value: _ctx.manualBooking.sttRecipientAddressType,
                        checked: 
                    _ctx.manualBooking.sttRecipientAddressType === item.value
                      ? true
                      : false
                  ,
                        id: item,
                        onChange: ($event: any) => (_ctx.onSelectAddressType(item.name, item.value)),
                        name: "radio-input",
                        class: "w-full whitespace-no-wrap my-2 z-10"
                      }, null, 40, ["value", "checked", "id", "onChange"]),
                      _createVNode("div", _hoisted_31, [
                        _createVNode(_component_Icons, {
                          name: item.name === 'Rumah' || item.name === 'Home' ? 'home-type' : 'office',
                          class: "cursor-pointer ml-2 h-6"
                        }, null, 8, ["name"]),
                        _createVNode("span", _hoisted_32, _toDisplayString(item.name), 1)
                      ])
                    ], 2))
                  }), 128))
                ]),
                _withDirectives(_createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35
                ], 512), [
                  [_vShow, 
                (_ctx.currentFieldIndex > 6.5 &&
                  !_ctx.manualBooking.sttRecipientAddressType) ||
                  !_ctx.manualBooking.sttRecipientAddressType
              ]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.districtOriginCity'),
                asterisk: "",
                class: "w-full mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    class: "my-2",
                    modelValue: _ctx.manualBooking.sttOriginAddress,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.manualBooking.sttOriginAddress = $event)),
                    placeholder: _ctx.$t('bookingShipment.placeholder.districtOriginCity'),
                    "is-disabled": ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.districtDestinationCity'),
                asterisk: "",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    class: "my-2",
                    onFilter: _ctx.fetchDestinationCity,
                    isLoading: _ctx.isLoadingDestinationCity,
                    options: _ctx.destinationCityList,
                    keyName: "name",
                    keyValue: "id",
                    placeholder: _ctx.$t('bookingShipment.placeholder.districtDestinationCity'),
                    modelValue: _ctx.manualBooking.sttDestinationAddress,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.manualBooking.sttDestinationAddress = $event)),
                    onChange: _ctx.setDestination,
                    onFocus: _cache[32] || (_cache[32] = 
                () => {
                  _ctx.setFieldIndex(7);
                  _ctx.fetchDestinationCity(
                    (_ctx.manualBooking.sttDestinationAddress.name
                      ? _ctx.manualBooking.sttDestinationAddress.name.split('')[0]
                      : _ctx.manualBooking.sttDestinationAddress.split('')[0]) || ''
                  );
                }
              ),
                    isShowErrorIndicator: 
                _ctx.errorDestinationCity ||
                  _ctx.errorEmbargo.destinationCity ||
                  _ctx.manualBooking.sttDestinationAddress.status === 'inactive' ||
                  _ctx.errorMandatory[7] ||
                  !_ctx.isVendorNinjaValid
              ,
                    errorCaption: 
                `${
                  !_ctx.isVendorNinjaValid
                    ? ''
                    : _ctx.manualBooking.sttDestinationAddress.status === 'inactive'
                    ? _ctx.$t('bookingShipment.error.inactiveCity')
                    : _ctx.errorMandatory[7] ? _ctx.$t('bookingShipment.error.destination') : ''
                }`
              ,
                    isShowErrorMessage: false,
                    isDisabled: _ctx.isDisableDeliveryReceiver
                  }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "onChange", "isShowErrorIndicator", "errorCaption", "isDisabled"]),
                  (_ctx.isVendorNinja)
                    ? (_openBlock(), _createBlock(_component_ErrorMessageBooking, {
                        key: 0,
                        type: 
                _ctx.manualBooking.sttDestinationAddess?.type?.toLowerCase() ===
                'vendor_lanjutan'
                  ? 'lanjutan'
                  : ''
              ,
                        isValid: _ctx.isVendorNinjaValid
                      }, null, 8, ["type", "isValid"]))
                    : _createCommentVNode("", true),
                  (_ctx.isDisableDeliveryReceiver && _ctx.manualBooking.sttIsCod && !_ctx.isSttForeign)
                    ? (_openBlock(), _createBlock(_component_WarningSttCod, {
                        key: 1,
                        type: _ctx.deliveryFeeType
                      }, null, 8, ["type"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            (_ctx.isProductInterpack)
              ? (_openBlock(), _createBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode("div", _hoisted_39, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('bookingShipment.column.postalCode'),
                      asterisk: "",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectSearch, {
                          serverSide: false,
                          onFocus: _cache[33] || (_cache[33] = ($event: any) => (_ctx.setFieldIndex(7.5))),
                          onFilter: _ctx.setPostalCodeDestination,
                          placeholder: _ctx.$t('bookingShipment.placeholder.postalCode'),
                          class: "mt-2",
                          keyName: "name",
                          keyValue: "id",
                          options: _ctx.postalCodeDestinationOptions,
                          modelValue: _ctx.manualBooking.postalCodeDestination,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.manualBooking.postalCodeDestination = $event)),
                          isShowErrorIndicator: 
                  _ctx.currentFieldIndex > 7.5 &&
                    !_ctx.manualBooking.postalCodeDestination
                ,
                          errorCaption: 
                  _ctx.currentFieldIndex > 7.5 &&
                  !_ctx.manualBooking.postalCodeDestination
                    ? _ctx.$t('bookingShipment.error.postalCode')
                    : ''
                ,
                          isDisabled: _ctx.isDisableDeliveryReceiver,
                          onChange: _ctx.checkFocus
                        }, null, 8, ["onFilter", "placeholder", "options", "modelValue", "isShowErrorIndicator", "errorCaption", "isDisabled", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode(_component_Checkbox, {
                    id: "sender",
                    modelValue: _ctx.existCustomerSender.existSender,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.existCustomerSender.existSender = $event)),
                    binary: true,
                    onFocus: _cache[36] || (_cache[36] = ($event: any) => (_ctx.onSaveCustomer($event, 'sender'))),
                    disabled: _ctx.disableSaveSender || _ctx.isDisableDeliverySender,
                    onChange: _ctx.checkFocus
                  }, null, 8, ["modelValue", "disabled", "onChange"]),
                  _createVNode("label", {
                    class: "ml-2.5",
                    for: "sender",
                    style: `${_ctx.disableSaveSender ? `color:#9e9e9e` : ''}`
                  }, _toDisplayString(_ctx.$t('bookingShipment.action.saveShipperData')), 5)
                ])
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("div", _hoisted_44, [
                  _createVNode(_component_Checkbox, {
                    id: "receiver",
                    modelValue: _ctx.existCustomerReceiver.existReceiver,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.existCustomerReceiver.existReceiver = $event)),
                    binary: true,
                    onFocus: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onSaveCustomer($event, 'receiver'))),
                    disabled: _ctx.disableSaveReceiver || _ctx.isDisableDeliveryReceiver,
                    onChange: _ctx.checkFocus
                  }, null, 8, ["modelValue", "disabled", "onChange"]),
                  _createVNode("label", {
                    class: "ml-2.5",
                    for: "receiver",
                    style: `${_ctx.disableSaveReceiver ? `color:#9e9e9e` : ''}`
                  }, _toDisplayString(_ctx.$t('bookingShipment.action.saveRecipientData')), 5)
                ])
              ])
            ]),
            _hoisted_45,
            _createVNode(_component_Title, {
              label: _ctx.$t('bookingShipment.column.itemDetails')
            }, null, 8, ["label"]),
            (!_ctx.isSttForeign)
              ? (_openBlock(), _createBlock(_component_BannerProductType, {
                  key: 3,
                  class: "mt-8"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('bookingShipment.column.selectServiceType'),
              asterisk: "",
              class: "w-full mr-4 mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_product_poster, {
                  class: "mt-3",
                  ref: "renderPoster",
                  productType: _ctx.manualBooking.sttProductTypeName.toLowerCase() === 'jumbopackh2h' ? 'jumbopack' : _ctx.manualBooking.sttProductTypeName.toLowerCase(),
                  isDisabledProduct: _ctx.isDisabledProduct,
                  onChoseeProduct: _ctx.onSelectProduct,
                  onSetErrorTriggered: _ctx.setErrorDestintaionProductUpselling,
                  isOnePack: _ctx.isOnePack,
                  isFormForeign: _ctx.isSttForeign,
                  isSameday: _ctx.showSameDay,
                  isEdit: ""
                }, null, 8, ["productType", "isDisabledProduct", "onChoseeProduct", "onSetErrorTriggered", "isOnePack", "isFormForeign", "isSameday"]),
                (_ctx.errorProduct)
                  ? (_openBlock(), _createBlock("div", _hoisted_46, [
                      _createVNode(_component_Icons, {
                        name: "warning-triangle",
                        class: " w-4"
                      }),
                      _createVNode("p", _hoisted_47, _toDisplayString(_ctx.errorProduct), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode("div", _hoisted_48, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bookingShipment.column.commodity'),
                asterisk: "",
                class: "w-1/2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    "is-disabled": _ctx.isDisabledCommodity,
                    class: "my-2",
                    options: _ctx.commodities,
                    onFilter: _ctx.fetchCommodityList,
                    keyName: "name",
                    keyValue: "code",
                    placeholder: _ctx.$t('bookingShipment.placeholder.commodity'),
                    modelValue: _ctx.manualBooking.sttCommodityName,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.manualBooking.sttCommodityName = $event)),
                    onChange: _ctx.onChangeCommodities,
                    isShowErrorMessage: false,
                    isShowErrorIndicator: 
                _ctx.errorEmbargo.comodity ||
                  _ctx.manualBooking.sttCommodityName.status === 'inactive' ||
                  _ctx.errorMandatory[9]
              ,
                    errorCaption: 
                `${
                  _ctx.manualBooking.sttCommodityName.status === 'inactive'
                    ? _ctx.$t('bookingShipment.error.inactiveCommodity')
                    : _ctx.$t('bookingShipment.error.commodity')
                }`
              ,
                    onFocus: _cache[40] || (_cache[40] = ($event: any) => (_ctx.setFieldIndex(9)))
                  }, null, 8, ["is-disabled", "options", "onFilter", "placeholder", "modelValue", "onChange", "isShowErrorIndicator", "errorCaption"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode("div", _hoisted_49, [
                _createVNode("div", _hoisted_50, [
                  _createVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('bookingShipment.column.insurance')), 1),
                  _hoisted_52,
                  _createVNode("div", _hoisted_53, [
                    _createVNode("img", {
                      onMouseenter: _cache[41] || (_cache[41] = ($event: any) => (_ctx.isOpenTooltipInsurance = true)),
                      onMouseleave: _cache[42] || (_cache[42] = ($event: any) => (_ctx.isOpenTooltipInsurance = false)),
                      src: 
                    _ctx.isOpenTooltipInsurance
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                      alt: ""
                    }, null, 40, ["src"]),
                    _withDirectives(_createVNode(_component_Tooltip, {
                      title: _ctx.$t('bookingShipment.tooltip.insurance'),
                      message: _ctx.$t('bookingShipment.tooltip.insuranceMsg'),
                      footer: "",
                      style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
                    }, null, 8, ["title", "message"]), [
                      [_vShow, _ctx.isOpenTooltipInsurance]
                    ])
                  ])
                ]),
                _createVNode(_component_Select, {
                  onOpenSelect: _ctx.onOpenSelectInsurance,
                  onCloseSelect: _ctx.onCloseSelectInsurance,
                  isOpenMenu: _ctx.isOpenSelectInsurance,
                  value: _ctx.getInsuranceName,
                  onChooseSelect: _ctx.onSelectStatusInsurance,
                  dataSelect: _ctx.listInsurance,
                  class: "w-full whitespace-no-wrap my-1.5 z-10",
                  isError: _ctx.error.insurance,
                  "is-disabled": _ctx.isDisabledInsuranceField || _ctx.disableAsuranceOtoPack
                }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError", "is-disabled"]),
                (_ctx.error.insurance)
                  ? (_openBlock(), _createBlock("p", _hoisted_54, _toDisplayString(_ctx.$t('bookingShipment.error.inactiveInsurance')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.itemPrice'),
                  asterisk: _ctx.getInsuranceName !== 'free',
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lp_input, {
                      disabled: _ctx.isDisabledGoodsPriceEstimation,
                      modelValue: _ctx.manualBooking.sttGoodsEstimatePrice,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.manualBooking.sttGoodsEstimatePrice = $event)),
                      onChange: _ctx.checkFocus,
                      prefix: _ctx.prefixCurrency,
                      format: _ctx.formatEstimationPrice,
                      onKeydown: _cache[44] || (_cache[44] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                      placeholder: "e.g 20.000",
                      error: _ctx.errorMandatory[10] || _ctx.errorEstimationPrice,
                      errorCaption: 
                  _ctx.errorEstimationPrice
                    ? 'Harga barang harus di atas atau sama dengan 5 juta'
                    : _ctx.$t('bookingShipment.error.itemPrice')
                ,
                      onFocus: _cache[45] || (_cache[45] = ($event: any) => (_ctx.setFieldIndex(10)))
                    }, null, 8, ["disabled", "modelValue", "onChange", "prefix", "format", "error", "errorCaption"])
                  ]),
                  _: 1
                }, 8, ["label", "asterisk"])
              ])
            ]),
            _createVNode(_component_Woodpacking, {
              ref: "woodpacking",
              modelValue: _ctx.manualBooking.sttIsWoodPacking,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.manualBooking.sttIsWoodPacking = $event)),
              city: _ctx.manualBooking.sttOriginCityId,
              isDisabled: _ctx.manualBooking.sttIsWoodPackingKeeped,
              eligibleAccess: _ctx.eligibleToWoodpacking,
              eligibleAccessForShipment: _ctx.woodpackingForshipment,
              onSetFocus: _ctx.checkFocus
            }, null, 8, ["modelValue", "city", "isDisabled", "eligibleAccess", "eligibleAccessForShipment", "onSetFocus"]),
            (!_ctx.isSttForeign)
              ? (_openBlock(), _createBlock("div", _hoisted_57, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryFeeTypes, (option) => {
                    return (_openBlock(), _createBlock("div", {
                      key: option.value,
                      class: "flex flex-col gap-y-4 mx-2 my-4 city-exclude-radio items-center"
                    }, [
                      _createVNode("div", {
                        class: 
              `p-field-radiobutton gap-x-3 flex flex-row ${option.logo ? 'items-center' : 'mt-3'}
              ${option.logo === 'dfod-logo' ? 'mt-2' : ''}`
                      }, [
                        _createVNode(_component_RadioButton, {
                          id: `radio-${option.value}`,
                          name: "cod",
                          value: option.value,
                          modelValue: _ctx.deliveryFeeType,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.deliveryFeeType = $event)),
                          disabled: option.disabled
                        }, null, 8, ["id", "value", "modelValue", "disabled"]),
                        _createVNode("label", {
                          for: `radio-${option.value}`,
                          class: `cursor-pointer flex ${option.logo ? 'items-center' : ''}`
                        }, [
                          (option.logo)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: require(`@/app/ui/assets/images/${option.logo}.png`),
                                class: "max-w-none w-12 mr-2",
                                alt: "cod-logo"
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true),
                          _createVNode("label", _hoisted_58, _toDisplayString(option.name), 1)
                        ], 10, ["for"])
                      ], 2)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showCodSection && !_ctx.isSttForeign)
              ? (_openBlock(), _createBlock("div", _hoisted_59, [
                  (_ctx.manualBooking.sttIsCod)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 0,
                        label: "Harga Barang COD",
                        class: "w-1/2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lp_input, {
                            modelValue: _ctx.manualBooking.sttCodAmount,
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.manualBooking.sttCodAmount = $event)),
                            prefix: _ctx.prefixCurrency,
                            disabled: true,
                            format: _ctx.formatEstimationPrice,
                            onKeydown: _cache[49] || (_cache[49] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                            placeholder: "0",
                            disableBackground: true
                          }, null, 8, ["modelValue", "prefix", "format"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _hoisted_60
                ]))
              : _createCommentVNode("", true),
            (_ctx.isFtzAccount)
              ? (_openBlock(), _createBlock("div", _hoisted_61, [
                  _hoisted_62,
                  _createVNode(_component_Title, {
                    label: _ctx.$t('bookingShipment.column.crossBorderInformation')
                  }, null, 8, ["label"]),
                  _createVNode("div", _hoisted_63, [
                    _createVNode("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, [
                        _createVNode("p", _hoisted_66, _toDisplayString(_ctx.$t('bookingShipment.column.taxIdentificationNumber')), 1),
                        (_ctx.isSttForeign)
                          ? (_openBlock(), _createBlock("span", _hoisted_67, "*"))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_68, [
                          _createVNode("img", {
                            onMouseenter: _cache[50] || (_cache[50] = ($event: any) => (_ctx.isOpenTooltipTax = true)),
                            onMouseleave: _cache[51] || (_cache[51] = ($event: any) => (_ctx.isOpenTooltipTax = false)),
                            src: 
                      _ctx.isOpenTooltipTax
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: _ctx.$t('bookingShipment.tooltip.tax'),
                            message: _ctx.$t('bookingShipment.tooltip.taxMsg'),
                            footer: "",
                            class: "w-200px ml-8",
                            style: {"margin-top":"-2.8em"}
                          }, null, 8, ["title", "message"]), [
                            [_vShow, _ctx.isOpenTooltipTax]
                          ])
                        ])
                      ]),
                      (!_ctx.isSttForeign)
                        ? (_openBlock(), _createBlock(_component_lp_input, {
                            key: 0,
                            modelValue: _ctx.manualBooking.sttTaxNumber,
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.manualBooking.sttTaxNumber = $event)),
                            format: _ctx.formatted,
                            onChange: _ctx.validateTaxNumber,
                            errorCaption: "Masukan No. Registrasi Pajak (NPWP) dengan benar",
                            error: _ctx.error.taxNumber,
                            placeholder: "00.000.000.0-000.000",
                            maxLength: "20",
                            disabled: _ctx.isDisabledStatusByPod,
                            "show-max-length": "",
                            onFocus: _cache[53] || (_cache[53] = ($event: any) => (_ctx.setFieldIndex(11)))
                          }, null, 8, ["modelValue", "format", "onChange", "error", "disabled"]))
                        : (_openBlock(), _createBlock(_component_lp_input, {
                            key: 1,
                            modelValue: _ctx.manualBooking.sttTaxNumber,
                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.manualBooking.sttTaxNumber = $event)),
                            placeholder: _ctx.$t('bookingShipment.placeholder.taxIdentificationNumber'),
                            maxLength: 20,
                            "show-max-length": "",
                            onFocus: _cache[55] || (_cache[55] = ($event: any) => (_ctx.setFieldIndex(11))),
                            onChange: _ctx.checkFocus
                          }, null, 8, ["modelValue", "placeholder", "onChange"]))
                    ]),
                    _createVNode("div", _hoisted_69, [
                      _createVNode("div", _hoisted_70, [
                        _createVNode("p", _hoisted_71, _toDisplayString(_ctx.$t('bookingShipment.column.shipmentStatus')), 1),
                        ((_ctx.isFtzAccount || _ctx.formType === 'client') && !_ctx.isSttForeign)
                          ? (_openBlock(), _createBlock("span", _hoisted_72, "*"))
                          : (_openBlock(), _createBlock("span", _hoisted_73, "(" + _toDisplayString(_ctx.$t('optional')) + ")", 1)),
                        _createVNode("div", _hoisted_74, [
                          _createVNode("img", {
                            onMouseenter: _cache[56] || (_cache[56] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = true)),
                            onMouseleave: _cache[57] || (_cache[57] = ($event: any) => (_ctx.isOpenTooltipStatusGoods = false)),
                            src: 
                      _ctx.isOpenTooltipStatusGoods
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                            alt: ""
                          }, null, 40, ["src"]),
                          _withDirectives(_createVNode(_component_Tooltip, {
                            title: _ctx.$t('bookingShipment.tooltip.shipmentStatus'),
                            message: _ctx.$t('bookingShipment.tooltip.shipmentStatusMsg'),
                            footer: "",
                            style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                          }, null, 8, ["title", "message"]), [
                            [_vShow, _ctx.isOpenTooltipStatusGoods]
                          ])
                        ])
                      ]),
                      _createVNode(_component_Select, {
                        onOpenSelect: 
                  () => {
                    _ctx.checkFocus();
                    _ctx.onOpenSelect();
                    _ctx.setFieldIndex(12);
                  }
                ,
                        onCloseSelect: _ctx.onCloseSelect,
                        isOpenMenu: _ctx.isStatusGoods,
                        value: _ctx.manualBooking.sttSenderStatus,
                        onChooseSelect: _ctx.onSelectStatus,
                        dataSelect: !_ctx.accountIsForeign ? _ctx.listStatusGoodsForIndonesian : _ctx.listStatusGoodsForEnglish,
                        class: "w-full whitespace-no-wrap my-1.5 z-10",
                        isError: !_ctx.isSttForeign ? _ctx.errorMandatory[12] : false,
                        isDisabled: _ctx.isDisabledStatusByPod
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isError", "isDisabled"]),
                      (!_ctx.isSttForeign && _ctx.errorMandatory[12])
                        ? (_openBlock(), _createBlock("div", _hoisted_75, [
                            _hoisted_76,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('bookingShipment.error.shipmentStatus')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_77, [
                    (!_ctx.isSttForeign)
                      ? (_openBlock(), _createBlock("div", _hoisted_78, [
                          _createVNode("div", _hoisted_79, [
                            _hoisted_80,
                            _hoisted_81,
                            _createVNode("div", _hoisted_82, [
                              _createVNode("img", {
                                onMouseenter: _cache[58] || (_cache[58] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = true)),
                                onMouseleave: _cache[59] || (_cache[59] = ($event: any) => (_ctx.isOpenTooltipPiecePerPack = false)),
                                src: 
                      _ctx.isOpenTooltipPiecePerPack
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                                alt: ""
                              }, null, 40, ["src"]),
                              _withDirectives(_createVNode(_component_Tooltip, {
                                title: "Piece Per Pack",
                                message: "Piece per pack adalah jumlah barang yang ada dalam satu koli.",
                                footer: "",
                                style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                              }, null, 512), [
                                [_vShow, _ctx.isOpenTooltipPiecePerPack]
                              ])
                            ])
                          ]),
                          _createVNode(_component_lp_input, {
                            modelValue: _ctx.manualBooking.sttPiecePerPack,
                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.manualBooking.sttPiecePerPack = $event)),
                            format: _ctx.formatPiecePerPack,
                            placeholder: "Masukan piece per pack",
                            error: _ctx.errorMandatory[13],
                            errorCaption: 
                  _ctx.errorMandatory[13] ? 'Piece per pack wajib diisi' : ''
                ,
                            onFocus: _cache[61] || (_cache[61] = ($event: any) => (_ctx.setFieldIndex(13))),
                            onChange: _ctx.checkFocus
                          }, null, 8, ["modelValue", "format", "error", "errorCaption", "onChange"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isSttForeign)
                      ? (_openBlock(), _createBlock("div", _hoisted_83, [
                          _createVNode("div", _hoisted_84, [
                            _hoisted_85,
                            _hoisted_86,
                            _createVNode("div", _hoisted_87, [
                              _createVNode("img", {
                                onMouseenter: _cache[62] || (_cache[62] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = true)),
                                onMouseleave: _cache[63] || (_cache[63] = ($event: any) => (_ctx.isOpenTooltipNextCommodity = false)),
                                src: 
                      _ctx.isOpenTooltipNextCommodity
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                                alt: ""
                              }, null, 40, ["src"]),
                              _withDirectives(_createVNode(_component_Tooltip, {
                                title: "Komoditas Selanjutnya",
                                message: "Isi dengan komoditas barang yang ada dalam satu koli.",
                                footer: "",
                                style: {"width":"250px","margin-left":"2.6em","margin-top":"-2.8em"}
                              }, null, 512), [
                                [_vShow, _ctx.isOpenTooltipNextCommodity]
                              ])
                            ])
                          ]),
                          _createVNode(_component_lp_input, {
                            modelValue: _ctx.manualBooking.sttNextCommodity,
                            "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.manualBooking.sttNextCommodity = $event)),
                            placeholder: "Masukan komoditas selanjutnya",
                            onChange: _ctx.validateNextCommodity,
                            error: _ctx.errorMandatory[14] || _ctx.error.nextCommodity,
                            errorCaption: "Komoditas selanjutnya wajib diisi",
                            onFocus: _cache[65] || (_cache[65] = ($event: any) => (_ctx.setFieldIndex(14))),
                            disabled: !_ctx.isInternal && _ctx.isReverseJourneyEditableReceiver
                          }, null, 8, ["modelValue", "onChange", "error", "disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isProductInterpack && _ctx.eligibleAdditionalInfo)
              ? (_openBlock(), _createBlock(_component_AdditionalInfo, {
                  key: _ctx.tabKey,
                  photos: _ctx.manualBooking.sttAttachFiles,
                  onUpdateFiles: _ctx.updateFiles,
                  commodity: _ctx.manualBooking.sttCommodityDetail,
                  onUpdateCommodity: _ctx.updateCommodity,
                  onSetFieldIndex: _ctx.setFieldIndex,
                  errorCommodity: _ctx.errorMandatory[15],
                  indexErrorCommodity: 15,
                  errorPhoto: _ctx.errorMandatory[16],
                  indexErrorPhoto: 16,
                  currentIndexError: _ctx.currentFieldIndex,
                  limitError: 17
                }, null, 8, ["photos", "onUpdateFiles", "commodity", "onUpdateCommodity", "onSetFieldIndex", "errorCommodity", "errorPhoto", "currentIndexError"]))
              : _createCommentVNode("", true),
            _hoisted_88,
            _createVNode(_component_Title, {
              label: "Detail Berat & Dimensi",
              class: "p-4 mb-6"
            }),
            _createVNode("div", {
              class: `w-full ${_ctx.disabledWeightAdjustment? 'bg-gray-lp-700 rounded mb-4' : ''}`
            }, [
              _createVNode("div", _hoisted_89, [
                _hoisted_90,
                _createVNode("div", _hoisted_91, [
                  _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.column.grossWeight')) + " ", 1),
                  _hoisted_92,
                  _hoisted_93,
                  _createVNode("div", _hoisted_94, [
                    _createVNode("img", {
                      onMouseenter: _cache[66] || (_cache[66] = ($event: any) => (_ctx.isOpenTooltipWeight = true)),
                      onMouseleave: _cache[67] || (_cache[67] = ($event: any) => (_ctx.isOpenTooltipWeight = false)),
                      src: 
                    _ctx.isOpenTooltipWeight
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                      alt: "",
                      class: "ml-2"
                    }, null, 40, ["src"]),
                    _withDirectives(_createVNode(_component_Tooltip, {
                      title: _ctx.$t('bookingShipment.tooltip.weight'),
                      message: _ctx.$t('bookingShipment.tooltip.weightMsg'),
                      footer: "",
                      style: {"width":"280px","margin-left":"2.6em","margin-top":"-2.6em"}
                    }, null, 8, ["title", "message"]), [
                      [_vShow, _ctx.isOpenTooltipWeight]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_95, [
                  _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.column.dimensionsPackage')) + " ", 1),
                  _createVNode("span", _hoisted_96, " (" + _toDisplayString(_ctx.$t('bookingShipment.placeholder.dimensionsPackage')) + ")", 1),
                  _hoisted_97
                ]),
                _createVNode("div", _hoisted_98, _toDisplayString(_ctx.$t('bookingShipment.column.dimensionWeight')), 1)
              ]),
              _createVNode("div", _hoisted_99, [
                _hoisted_100,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listKGs, (key, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "flex flex-col py-6 border-b"
                  }, [
                    _createVNode("div", _hoisted_101, [
                      _createVNode("div", _hoisted_102, _toDisplayString(index + 1), 1),
                      _createVNode("div", _hoisted_103, [
                        _createVNode(_component_lp_input, {
                          modelValue: key.grossWeight,
                          "onUpdate:modelValue": [($event: any) => (key.grossWeight = $event), ($event: any) => (_ctx.setOnValidationHws(key.grossWeight, index))],
                          format: _ctx.formatFloat,
                          onChange: _ctx.checkFocus,
                          placeholder: "e.g 20",
                          maxLength: _ctx.isMaxLengthGrossWeight,
                          error: 
                      _ctx.errorEmbargo.weightStatus ||
                        _ctx.validateFullFilledWeight(key.grossWeight) ||
                        _ctx.validateEditWeightLoss('grossWeight')
                    ,
                          errorCaption: 
                      _ctx.validateEditWeightLoss('grossWeight')
                        ? 'Perubahan penurunan berat tidak diijinkan'
                        : `Berat wajib diisi`
                    ,
                          isErrorIconCaption: false,
                          errorIcon: false,
                          onFocus: _cache[68] || (_cache[68] = ($event: any) => (_ctx.setFieldIndex(17))),
                          onOnClickViewDisabledInput: _ctx.onClickWeightAdjustment,
                          disabled: _ctx.isDisablePieceDetail || _ctx.disabledWeightAdjustment,
                          showViewDisabledInput: _ctx.disabledWeightAdjustment
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "format", "onChange", "maxLength", "error", "errorCaption", "onOnClickViewDisabledInput", "disabled", "showViewDisabledInput"])
                      ]),
                      _createVNode("div", _hoisted_104, [
                        _createVNode(_component_InputDimension, {
                          length: key.dimension.length,
                          "onUpdate:length": ($event: any) => (key.dimension.length = $event),
                          width: key.dimension.width,
                          "onUpdate:width": ($event: any) => (key.dimension.width = $event),
                          height: key.dimension.height,
                          "onUpdate:height": ($event: any) => (key.dimension.height = $event),
                          onInput: ($event: any) => (_ctx.calculationVolumeWeight(index)),
                          onChange: _ctx.checkFocus,
                          error: 
                      _ctx.errorEmbargo.lengthStatus ||
                        _ctx.validateFullFilledVolume(key.volumeWeight) ||
                        _ctx.validateEditWeightLoss('volumeWeight')
                    ,
                          errorCaption: 
                      _ctx.validateEditWeightLoss('volumeWeight')
                        ? 'Perubahan penurunan berat tidak diijinkan'
                        : _ctx.validateFullFilledVolume(key.volumeWeight)
                        ? 'Dimensi/paket wajib diisi'
                        : ''
                    ,
                          withIcon: false,
                          onOnClickViewDisabledInput: _ctx.onClickWeightAdjustment,
                          disabled: _ctx.isDisablePieceDetail || key.isDimensionDisabled || _ctx.disabledWeightAdjustment,
                          showViewDisabledInput: _ctx.disabledWeightAdjustment
                        }, null, 8, ["length", "onUpdate:length", "width", "onUpdate:width", "height", "onUpdate:height", "onInput", "onChange", "error", "errorCaption", "onOnClickViewDisabledInput", "disabled", "showViewDisabledInput"])
                      ]),
                      _createVNode("div", _hoisted_105, _toDisplayString(_ctx.volumeWeight(key.volumeWeight)) + " Kg ", 1)
                    ]),
                    (key.errorHws)
                      ? (_openBlock(), _createBlock("div", _hoisted_106, [
                          _hoisted_107,
                          _hoisted_108,
                          _createVNode("p", _hoisted_109, " Berat mulai " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg hanya 1 koli. Ubah berat atau booking baru. ", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.showWarningHws)
                  ? (_openBlock(), _createBlock("div", _hoisted_110, [
                      _hoisted_111,
                      _createVNode("div", _hoisted_112, [
                        _createVNode(_component_Icons, {
                          width: "16",
                          height: "16",
                          name: "announce",
                          class: "mr-2"
                        }),
                        _hoisted_113,
                        _createTextVNode(" Berat diatas " + _toDisplayString(_ctx.configHeavyWeightMinimum.heavyWeightMinimum) + " kg akan dikenakan biaya tambahan & Anda tidak dapat menambah koli lagi. ", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            (_ctx.errorMessageChWeight)
              ? (_openBlock(), _createBlock("div", _hoisted_114, [
                  _hoisted_115,
                  (_ctx.isErrorMaxChWeightGoods || _ctx.isErrorMaxChWeightDimension)
                    ? (_openBlock(), _createBlock("span", _hoisted_116, " Total berat melebihi batas maksimum. Cek & atur ulang berat. "))
                    : (_openBlock(), _createBlock("span", _hoisted_117, " Berat kotor sudah melebihi batas berat, Anda tidak bisa ubah berat lagi. "))
                ]))
              : _createCommentVNode("", true),
            (
            _ctx.onShowSectionAdjustmentWeight(
              _ctx.manualBooking.sttShipmentId,
              _ctx.manualBooking.sttNo
            )
          )
              ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjustment, {
                  key: 9,
                  ref: "section-weight-adjustment",
                  showViewAdjustment: _ctx.showViewAdjustment,
                  "onUpdate:showViewAdjustment": _cache[69] || (_cache[69] = ($event: any) => (_ctx.showViewAdjustment = $event)),
                  title: _ctx.$t('bookingV3.shipment.weightPieces.uploadWeightProofPhoto'),
                  watermark: _ctx.manualBooking.sttNo,
                  modelValue: _ctx.manualBooking.sttWeightAttachFiles,
                  onOnUploadImage: _ctx.upload,
                  onOnDeleteImage: _ctx.remove
                }, null, 8, ["showViewAdjustment", "title", "watermark", "modelValue", "onOnUploadImage", "onOnDeleteImage"]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: 
            `my-4 bg-gray-lp-700 p-3 rounded-md ${_ctx.validateTotalGrossWeight &&
              'border border-red-lp-100'}`
          
            }, [
              _createVNode("div", _hoisted_118, [
                _createVNode("div", _hoisted_119, [
                  _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.column.totalItem')) + " ", 1),
                  _createVNode("p", null, _toDisplayString(_ctx.listKGs.length), 1)
                ]),
                _createVNode("div", _hoisted_120, [
                  _createVNode("div", {
                    class: 
                  `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                    _ctx.isGrossWeight && !_ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.column.totalGrossWeight')) + " ", 1),
                    _createVNode("p", null, _toDisplayString(_ctx.totalGrossWeight) + " kg", 1)
                  ], 2),
                  (_ctx.validateTotalGrossWeight)
                    ? (_openBlock(), _createBlock("div", _hoisted_121, _toDisplayString(_ctx.$t('bookingShipment.error.weightMaximum')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isGrossWeight && _ctx.isCampaign)
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: 
                  `flex flex-row justify-between text-12px xxl:text-14px ${
                    _ctx.isGrossWeight && _ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                      }, [
                        _hoisted_122,
                        _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " kg ", 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_123, [
                  _createVNode("div", {
                    class: 
                  `flex flex-row justify-between text-12px xxl:text-14px mt-4 ${
                    _ctx.isVolumeWeight && !_ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.column.totalDimensionWeight')) + " ", 1),
                    _createVNode("p", null, _toDisplayString(_ctx.totalVolumeWeight) + " kg", 1)
                  ], 2),
                  (_ctx.validateTotalVolumeWeight)
                    ? (_openBlock(), _createBlock("div", _hoisted_124, _toDisplayString(_ctx.$t('bookingShipment.error.weightMaximum')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isVolumeWeight && _ctx.isCampaign)
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: 
                  `flex flex-row justify-between text-12px xxl:text-14px ${
                    _ctx.isVolumeWeight && _ctx.isCampaign
                      ? 'text-gray-lp-300 font-semibold'
                      : 'text-gray-lp-600 font-normal'
                  }`
                
                      }, [
                        _hoisted_125,
                        _createVNode("p", null, _toDisplayString(_ctx.totalCampaignChargeableWeight.toString().replace(".", ",")) + " kg ", 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_126,
                _createVNode("div", _hoisted_127, [
                  _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.column.chargeableWeight')) + " ", 1),
                  _createVNode("p", null, _toDisplayString(_ctx.isCampaign
                    ? _ctx.totalCampaignChargeableWeight.toString().replace(".", ",")
                    : _ctx.totalChargeableWeight) + " kg ", 1)
                ])
              ])
            ], 2),
            _hoisted_128
          ])
        ])),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.closeModalError,
          title: _ctx.titleErrorspesification,
          message: _ctx.errorCause,
          image: "image-modal-warning",
          textSuccess: "OK",
          class: "px-8"
        }, null, 8, ["onSubmit", "title", "message"]), [
          [_vShow, _ctx.isErrorAdd && _ctx.isErrorSpesificRate]
        ]),
        (_ctx.isErrorAdd && !_ctx.isErrorSpesificRate)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onCancel: _ctx.closeModalError,
              onTryAgain: _ctx.booking,
              modal: ""
            }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.onCloseSuccess,
          title: _ctx.$t('Perubahan Booking Berhasil !'),
          message: `Detail STT “${_ctx.manualBooking.sttNo}” ${_ctx.$t('bookingShipment.message.updated')}.`,
          image: "image-modal-success",
          textSuccess: "OK",
          class: "px-8"
        }, {
          custom: _withCtx(() => [
            (_ctx.discount.isDiscount)
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 0,
                  isShadow: false,
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode("h2", _hoisted_129, _toDisplayString(_ctx.$t('bookingShipment.error.totalPayment')), 1),
                    _createVNode("div", _hoisted_130, [
                      _createVNode("div", _hoisted_131, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalBeforeDiscount)), 1),
                      _createVNode("div", _hoisted_132, _toDisplayString(_ctx.formatPrice(_ctx.discount.totalAfterDiscount)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onSubmit", "title", "message"]), [
          [_vShow, _ctx.openSuccess]
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onSubmit: _ctx.handlerClose,
          onClose: _ctx.handlerCancelClose,
          title: _ctx.$t('Yakin Keluar Halaman?'),
          message: _ctx.$t('Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar dari halaman ini.'),
          image: "badge-confirmation-general",
          textSuccess: _ctx.$t('bookingShipment.action.buttonQuit'),
          textCancel: _ctx.$t('bookingShipment.action.buttonStay'),
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
          [_vShow, _ctx.isEditTerminated]
        ]),
        _createVNode(_component_ModalErrorNotAllowEdit, {
          "custom-path": _ctx.customPath,
          show: _ctx.isModalNotAllowEdit
        }, null, 8, ["custom-path", "show"])
      ], 64))
}